import * as S from './style'
import LayoutDetails from '../../../../components/LayoutModal/LayoutDetails';
import axiosInstance from 'services/axiosInstance';
import { useEffect, useState } from 'react';
import Loading from '../../../../components/Loading';
import useLoading from "../../../../hooks/useLoading";
//Interface
import { ISupplier } from 'Interfaces/ISupllier';
// utils
import FormatarData from 'utils/FormatData';

interface IDetails {
    isOpenModal: boolean;
    setModalClose: () => void;
    selectedUrlId: number | null;
}

export default function Details({ isOpenModal, setModalClose, selectedUrlId }: IDetails) {
    const [data, setData] = useState<ISupplier | null>(null);
    const { isLoading, startLoading, stopLoading } = useLoading();

    const fetchData = async () => {
        startLoading();
        try {
            const response = await axiosInstance.get(`supplier/${selectedUrlId}`);
            setData(response.data);
        } catch (error) {
            console.log('Error: ', error);
        } finally {
            stopLoading();
        }
    }

    useEffect(() => {
        if (selectedUrlId !== null) {
            fetchData();
        }
    }, [selectedUrlId])

    if (isOpenModal) {
        return (
            <LayoutDetails
                title='Detalhes do Fornecedor'
                subTitle='Veja todos os detalhes disponíveis sobre o Fornecedor.'
                setModalClose={setModalClose}>
                {isLoading || !data ? ( // Se estiver carregando ou os dados forem nulos, mostra o loading
                    <Loading />
                ) : (
                    <S.Content>
                        <S.Header>
                            <S.ContentInfor>
                                <S.Infor>
                                    <p>Nome:</p>
                                    <span>{data.name || '-'}</span>
                                </S.Infor>
                                <S.Infor>
                                    <p>Contato:</p>
                                    <span>{data.contact || '-'}</span>
                                </S.Infor>
                                <S.Infor>
                                    <p>E-mail:</p>
                                    <span>{data.email || '-'}</span>
                                </S.Infor>
                            </S.ContentInfor>
                        </S.Header>

                        <S.Body>
                            <S.FeaturedSection>
                                <S.InforBody>
                                    <p>Descrição</p>
                                    <S.Description>{data.description || '-'}</S.Description>
                                </S.InforBody>
                            </S.FeaturedSection>

                            <S.InforBody>
                                <S.InforSmall>Cadastrado em: {FormatarData(data.created_at || "-")}</S.InforSmall>
                                <S.InforSmall>Ultima atualização em: {FormatarData(data.updated_at) || "-"}</S.InforSmall>
                            </S.InforBody>
                        </S.Body>
                    </S.Content>
                )}
            </LayoutDetails>
        )
    } return null
}